import type { AnyFieldApi } from "@tanstack/solid-form";
import { onMount, splitProps } from "solid-js";
import { formatCurrency, parseInputValue } from "@/libs/format";

interface UseCurrencyInputHelperProps {
  fieldApi: AnyFieldApi;
  currency?: string;
}

export const useCurrencyInputHelper = (props: UseCurrencyInputHelperProps) => {
  const [localProps] = splitProps(props, ["fieldApi", "currency"]);

  const handleChange = (e: Event) => {
    const target = e.target as HTMLInputElement;
    const cleanValue = parseInputValue(target.value);
    localProps.fieldApi.handleChange(cleanValue);
  };

  const handleInput = (e: Event) => {
    const target = e.target as HTMLInputElement;
    const cleanValue = parseInputValue(target.value);
    localProps.fieldApi.handleChange(cleanValue);
  };

  const handleBlur = (e: Event) => {
    const target = e.target as HTMLInputElement;
    if (target.value) {
      const numericValue = Number(parseInputValue(target.value));
      if (!Number.isNaN(numericValue)) {
        const formattedValue = formatCurrency(
          numericValue,
          localProps.currency,
        );
        localProps.fieldApi?.handleBlur();
        localProps.fieldApi.handleChange(formattedValue);
      }
    } else {
      localProps.fieldApi?.handleBlur();
      localProps.fieldApi.handleChange("");
    }
  };

  const handleFocus = (e: Event) => {
    const target = e.target as HTMLInputElement;
    if (target.value) {
      const parsedValue = parseInputValue(target.value);
      localProps.fieldApi.handleChange(parsedValue);
    }
  };

  onMount(() => {
    if (localProps.fieldApi.state.value) {
      const parsedValue = parseInputValue(localProps.fieldApi.state.value);
      localProps.fieldApi.handleChange(parsedValue);
    }
  });

  return {
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onInput: handleInput,
  };
};
